import { z } from 'zod';

export const renameCropRequestSchema = z.object({
  localPath: z.string(),
  newFilename: z.string(),
});

export type IRenameCropRequest = z.infer<typeof renameCropRequestSchema>;
